// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionHeader_wrapper__R37qw","title":"SectionHeader_title__pUmbZ","actions":"SectionHeader_actions__yXgt8"};